import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionSyncService {
  private channel = new BroadcastChannel('session-sync');
  private apiBaseUrl = environment.url;
  sessionTerminated$ = new Subject<string>();
  sessionExtended$ = new Subject<string>();

  constructor(private http: HttpClient) {
    this.channel.onmessage = event => {
      const { type, data } = event.data;
      switch (type) {
        case 'SESSION_TERMINATED':
          this.sessionTerminated$.next(data);
          break;
        case 'SESSION_EXTENDED':
          this.sessionExtended$.next(data);
          break;
      }
    };
  }

  notifySessionTerminated(message: string) {
    this.channel.postMessage({ type: 'SESSION_TERMINATED', data: message });
  }

  notifySessionExtended(userId: string) {
    this.channel.postMessage({ type: 'SESSION_EXTENDED', data: userId });
  }

  notifyLastTabClosed(deviceId: string, type: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/Login/lastTabClosed`, {
      deviceId: deviceId,
      timestamp: new Date().toISOString(),
      ipAddress: null,
      type: type,
    });
  }
}
